<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-80 jsonPopup"
          :style="{ 'max-height': getMaxHeightClient() + 'px' }"
          @mousedown="dontClose">
          <div>
            <b-row>
              <b-col style="text-align:end;">
                <i class="fa fa-times close-button" style="font-size:20px" @click="handleMouseDown"></i>
              </b-col>
            </b-row>
          </div>
          <div class="modal-body" style="overflow:auto;" :style="{'max-height' : ((getMaxHeightClient() * 0.85)) + 'px'}">
            <b-container fluid>
              <b-row v-if="isPopupActive">
                Contenu des Termes et conditions à ajouter
              </b-row>
            </b-container>
          </div>
          <div class="modal-footer">
            <b-col lg="2" sm="3" cols="6" class="p-0 m-0">
              <b-button variant="primary" @click="$emit('close')">{{ $t('common.close_label') }}</b-button>
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

import backButton from '@/components/common/backButton.vue'

export default {
  name: 'CMTermsConditions',
  components: {
    'back-button': backButton
  },
  data () {
    return {
      isPopupActive: true,
      highlightedJsonData: '',
      mousedown: false,
      jsonData: ''
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight - 50
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height:' + maxHeight + 'px')
    },
    dontClose (e) {
      e.stopPropagation()
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight - 50
    },
    handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    handleMouseUp (e) {
      this.mousedown = false
    }
  }
}

</script>
